import React, { useEffect, useState } from "react";
import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import api from "@/lib/api";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const [biz, setBiz] = useState(null);
  const loc = useLocation();
  useEffect(() => {
    api.get("/business").then(r => setBiz(r.data)).catch(() => {});
  }, []);
  if (loc.pathname.startsWith("/admin")) return null;
  const b = biz || {};
  return (
    <footer className="bg-[#0F172A] text-[#FFFFFF] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif-display text-4xl">Hedieh's Alterations</div>
          <p className="mt-4 text-[#F8FAFC]/70 max-w-md leading-relaxed">{b.tagline}</p>
          <div className="mt-8 space-y-3 text-sm">
            <div className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#D4AF37]"/><span>{b.office_address}</span></div>
            <div className="flex items-center gap-3"><Phone size={16} className="text-[#D4AF37]"/><a href={`tel:${b.phone}`} className="link-underline">{b.phone}</a></div>
            <div className="flex items-center gap-3"><MessageCircle size={16} className="text-[#D4AF37]"/><a href={`https://wa.me/${(b.whatsapp||"").replace(/[^0-9]/g,"")}`} className="link-underline">WhatsApp us</a></div>
            <div className="flex items-start gap-3"><Clock size={16} className="mt-0.5 text-[#D4AF37]"/><span>{b.opening_hours}</span></div>
          </div>
        </div>
        <div>
          <div className="overline text-[#D4AF37]">Our Shops</div>
          <ul className="mt-6 space-y-3 text-sm">
            {(b.shops || []).map(s => <li key={s} className="text-[#F8FAFC]/80">{s}</li>)}
          </ul>
        </div>
        <div>
          <div className="overline text-[#D4AF37]">Explore</div>
          <ul className="mt-6 space-y-3 text-sm">
            <li><Link to="/" className="link-underline">Home</Link></li>
            <li><Link to="/book" className="link-underline">Book a Fitting</Link></li>
            <li><Link to="/track" className="link-underline">Track Your Order</Link></li>
            <li><Link to="/admin" className="link-underline text-[#F8FAFC]/50">Staff Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-[#F8FAFC]/50 flex flex-wrap gap-4 justify-between">
          <div>© {new Date().getFullYear()} Hedieh's Alterations · Rhodes NSW</div>
          <div>Handcrafted in Sydney</div>
        </div>
      </div>
    </footer>
  );
}
